/**
 * Capture acquisition signals (document.referrer + utm_* params) on first load
 * and consume them when a new user signs up. Survives the Google OAuth popup
 * via sessionStorage.
 */

const STORAGE_KEY = 'chag.signupSource.v1';
const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];

export function captureSignupSource() {
  if (typeof window === 'undefined' || !window.sessionStorage) return;
  if (sessionStorage.getItem(STORAGE_KEY)) return;

  const params = new URLSearchParams(window.location.search);
  const utm = {};
  UTM_KEYS.forEach((k) => {
    const v = params.get(k);
    if (v) utm[k] = v;
  });

  const payload = {
    referrer: document.referrer || null,
    landingPath: window.location.pathname || null,
    capturedAt: new Date().toISOString(),
    ...utm,
  };

  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
  } catch (e) {
    // sessionStorage can be unavailable in private browsing; non-fatal.
  }
}

export function consumeSignupSource() {
  if (typeof window === 'undefined' || !window.sessionStorage) return null;
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    sessionStorage.removeItem(STORAGE_KEY);
    return JSON.parse(raw);
  } catch (e) {
    return null;
  }
}
